/** localStorage keys for NgRx feature persistence (filter / sort / pagination / drafts). */
export const NGRX_STORAGE_KEYS = {
  applyJob: 'elevateme.applyJob',
  quickApplication: 'elevateme.quickApplication',
  companyList: 'elevateme.companyList',
  jobsList: 'elevateme.jobsList',
  studentsList: 'elevateme.studentsList',
  interviewsList: 'elevateme.interviewsList',
  applicationsList: 'elevateme.applicationsList',
  usersList: 'elevateme.usersList'
} as const;

const ALL_KEYS = Object.values(NGRX_STORAGE_KEYS);

export function clearNgRxPersistedLocalStorage(): void {
  for (const key of ALL_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* quota / private mode */
    }
  }
}
